<template>
  <v-layout>
    <v-card>
      <v-card-text>
        <v-row>
          <v-col class="text-center" cols="12" md="12">
            <h4>{{ formTitle }}</h4>
          </v-col>

          <!--Datos-->
          <v-col cols="12" md="12">
            <v-row>
              <v-col cols="12" sm="4" md="4" lg="2">
                <v-menu
                  v-model="dateFR"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="object.fecha_recogida"
                      label="Fecha Entrega"
                      prepend-icon="event"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      dense
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="date_FR"
                    @input="dateFR = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="4" md="4" lg="2">
                <v-autocomplete
                  v-model="object.lugar_recogida"
                  :items="lugarArr"
                  prepend-icon="location_on"
                  dense
                  label="Lugar entrega"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="4" md="4" lg="2">
                <v-autocomplete
                  :items="horariosArr"
                  v-model="object.hora_recogida"
                  prepend-icon="access_time"
                  label="Horario de entrega"
                  dense
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="4" md="4" lg="2">
                <v-menu
                  v-model="dateFE"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="object.fecha_entrega"
                      label="Fecha Devolución"
                      prepend-icon="event"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      dense
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="date_FE"
                    @input="dateFE = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="4" md="4" lg="2">
                <v-autocomplete
                  v-model="object.lugar_entrega"
                  :items="lugarArr"
                  prepend-icon="location_on"
                  dense
                  label="Lugar Devolución"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="4" md="4" lg="2">
                <v-autocomplete
                  :items="horariosArr"
                  v-model="object.hora_entrega"
                  prepend-icon="access_time"
                  label="Horario devolución"
                  dense
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="4" md="4" lg="2">
                <v-autocomplete
                  v-model="object.edad_conductor"
                  :items="edadArr"
                  dense
                  label="Edad del conductor"
                  prepend-icon="face"
                  placeholder="25 años"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="4" md="4" lg="2">
                <v-autocomplete
                  v-model="object.coche_grupo"
                  :items="gruposArr"
                  @change="changeGrupo"
                  dense
                  label="Grupo"
                  placeholder="Grupo"
                  prepend-icon="group_work"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="4" md="4" lg="2">
                <v-autocomplete
                  v-model="object.id_coche"
                  :items="cochesArr"
                  dense
                  label="Coche"
                  prepend-icon="directions_car"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="4" md="4" lg="2">
                <v-autocomplete
                  v-model="object.coche_modelo"
                  :items="cochesModelArr"
                  dense
                  label="Modelo"
                  prepend-icon="directions_car"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="4" md="4" lg="2">
                <v-autocomplete
                  v-model="object.coche_matricula"
                  :items="cochesMatriculaArr"
                  dense
                  label="Matrícula"
                  prepend-icon="web_asset"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="4" md="4" lg="2">
                <v-autocomplete
                  v-model="object.id_persona"
                  :items="clientesArr"
                  dense
                  prepend-icon="assignment_ind"
                  label="Cliente"
                  placeholder="Cliente"
                ></v-autocomplete>
                <!-- <v-icon dense>add</v-icon> -->
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="4" md="4" lg="2">
                <v-autocomplete
                  v-model="object.tipo_francdepos"
                  :items="francdeposArr"
                  @change="changeFrancRepos"
                  dense
                  label="Franquicia o Deposito"
                  prepend-icon="security"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="4" md="4" lg="2">
                <v-text-field
                  v-model="object.valor_francdepos"
                  dense
                  label="Valor"
                  prepend-icon="attach_money"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="4" lg="2">
                <v-text-field
                  v-model="object.tarifa"
                  dense
                  label="Tarifa"
                  prepend-icon="attach_money"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="4" lg="2">
                <v-text-field
                  v-model="object.total"
                  dense
                  label="Total"
                  prepend-icon="attach_money"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="4" md="12" lg="12">
                <v-text-field
                  type="text"
                  v-model="object.observaciones"
                  prepend-icon="web_asset"
                  dense
                  label="Observaciones"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn color="blue darken-1" text @click="close">
          Resetear
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn v-if="!detalle" color="blue darken-1" text @click="guardar">
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-layout>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import axios from "axios";

export default {
  data() {
    return {
      progress: false,
      dialog: false,
      date_FR: new Date().toISOString().substr(0, 10),
      date_FE: new Date().toISOString().substr(0, 10),
      dateFE: false,
      dateFR: false,
      tarifa: 0,
      lugarArr: ["Oficina central", "Aeropuerto"],
      horariosArr: [
        { text: "00:00", value: "00:00" },
        { text: "00:30", value: "00:30" },
        { text: "01:00", value: "01:00" },
        { text: "01:30", value: "01:30" },
        { text: "02:00", value: "02:00" },
        { text: "02:30", value: "02:30" },
        { text: "03:00", value: "03:00" },
        { text: "03:30", value: "03:30" },
        { text: "04:00", value: "04:00" },
        { text: "04:30", value: "04:30" },
        { text: "05:00", value: "05:00" },
        { text: "05:30", value: "05:30" },
        { text: "06:00", value: "06:00" },
        { text: "06:30", value: "06:30" },
        { text: "07:00", value: "07:00" },
        { text: "07:30", value: "07:30" },
        { text: "08:00", value: "08:00" },
        { text: "08:30", value: "08:30" },
        { text: "09:00", value: "09:00" },
        { text: "09:30", value: "09:30" },
        { text: "10:00", value: "10:00" },
        { text: "10:30", value: "10:30" },
        { text: "11:00", value: "11:00" },
        { text: "11:30", value: "11:30" },
        { text: "12:00", value: "12:00" },
        { text: "12:30", value: "12:30" },
        { text: "13:00", value: "13:00" },
        { text: "13:30", value: "13:30" },
        { text: "14:00", value: "14:00" },
        { text: "14:30", value: "14:30" },
        { text: "15:00", value: "15:00" },
        { text: "15:30", value: "15:30" },
        { text: "16:00", value: "16:00" },
        { text: "16:30", value: "16:30" },
        { text: "17:00", value: "17:00" },
        { text: "17:30", value: "17:30" },
        { text: "18:00", value: "18:00" },
        { text: "18:30", value: "18:30" },
        { text: "19:00", value: "19:00" },
        { text: "19:30", value: "19:30" },
        { text: "20:00", value: "20:00" },
        { text: "20:30", value: "20:30" },
        { text: "21:00", value: "21:00" },
        { text: "21:30", value: "21:30" },
        { text: "22:00", value: "22:00" },
        { text: "22:30", value: "22:30" },
        { text: "23:00", value: "23:00" },
        { text: "23:30", value: "23:30" },
      ],
      edadArr: [],
      cochesArr: [],
      cochesModelArr: [],
      cochesMatriculaArr: [],
      gruposArr: [],
      tarifasArr: [],
      francdeposArr: ["Franquicia", "Depósito"],
      clientesArr: [],
      totalPagar: 0,
    };
  },
  props: {
    object: Object,
    update: Boolean,
    detalle: Boolean,
  },
  created() {
    moment.locale("ES");
    this.selectCochesFn();
    this.selectClientesFn();
    this.selectGruposFn();
    this.selectEdadesFn();
  },
  computed: {
    ...mapState("usuarioNamespace", ["token", "usuario"]),
    ...mapState("cocheNamespace", ["coches"]),
    ...mapState("clienteNamespace", ["clientes"]),
    ...mapState("grupoNamespace", ["grupos"]),
    formTitle() {
      let me = this;
      let titulo = "";
      if (me.update) {
        titulo = "Edución de registro";
      } else if (me.detalle) {
        titulo = "Detalle";
      } else {
        titulo = "Nuevo registro";
      }
      return titulo;
    },
  },
  methods: {
    selectEdadesFn() {
      let me = this;
      for (let i = 25; i >= 25 && i <= 85; i++) {
        me.edadArr.push(i);
      }
    },
    selectGruposFn() {
      let me = this;
      let arr = this.grupos;
      arr.forEach((x) => {
        me.gruposArr.push({ text: x.nombre, value: x.id });
      });
    },
    selectCochesFn() {
      let me = this;
      let arr = this.coches;
      arr.forEach((x) => {
        if (x.estado == 1) {
          me.cochesArr.push({ text: x.marca, value: x.id });
          me.cochesModelArr.push({ text: x.modelo, value: x.modelo });
          me.cochesMatriculaArr.push({ text: x.matricula, value: x.coche_matricula });
        }
        if(this.detalle) {
          me.cochesArr.push({ text: x.marca, value: x.id });
          me.cochesModelArr.push({ text: x.modelo, value: x.modelo });
          me.cochesMatriculaArr.push({ text: x.matricula, value: x.matricula });
        }
      });
    },
    selectClientesFn() {
      let me = this;
      let arr = this.clientes;
      arr.forEach((x) => {
        me.clientesArr.push({ text: x.nombre + x.apellido, value: x.id });
      });
    },
    changeGrupo() {
      let me = this;
      this.cochesArr = [];
      this.cochesModelArr = [];
      this.cochesMatriculaArr = [];
      let coches = this.coches;
      let grupo = this.object.coche_grupo;
      coches.forEach((x) => {
        if (grupo == x.grupo && x.estado == 1) {
          me.cochesArr.push({ text: x.marca, value: x.id });
          me.cochesModelArr.push({ text: x.modelo, value: x.modelo });
          me.cochesMatriculaArr.push({ text: x.matricula, value: x.matricula });
        }
      });
    },
    changeFrancRepos() {
      let me = this;
      let grupos = this.grupos;
      let grupo = this.object.coche_grupo;
      let tipo = this.object.tipo_francdepos;
      if (tipo == "Franquicia") {
        grupos.forEach((x) => {
          if (grupo == x.id) {
            me.object.valor_francdepos = x.valor_franquicia;
          }
        });
      } else {
        grupos.forEach((x) => {
          if (grupo == x.id) {
            me.object.valor_francdepos = x.valor_deposito;
          }
        });
      }
    },
    guardar() {
      let me = this;
      let arr = this.coches;
      arr.forEach((x) => {
        if (x.id == me.object.id_coche) {
          me.object.coche_marca = x.marca;
        }
      });
      let clientes = this.clientes;
      clientes.forEach((x) => {
        if(this.object.id_persona == x.id) {
          me.object.nombre = x.nombre;
          me.object.apellido = x.apellido;
          me.object.telefono = x.telefono_movil;
          me.object.email = x.email;
        }
      });
      let grupos = this.grupos;
      grupos.forEach((x) => {
        if(this.object.coche_grupo == x.id) {
          me.object.coche_grupo = x.nombre;
        }
      });
      this.$emit("save", this.object);
    },
    close() {
      this.$emit("close");
    },
  },
  watch: {
    date_FR: function(val) {
      this.object.fecha_recogida = moment(val).format("LL");
    },
    date_FE: function(val) {
      this.object.fecha_entrega = moment(val).format("LL");
    },
  },
};
</script>
